export default __webpack_public_path__ + "static/media/ic_arrow_mydata_location.fadcecad.svg";